export default __webpack_public_path__ + "static/media/zoom.3f9422b3.svg";